import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash } from 'react-icons/fa';
import ReactPaginate from 'react-paginate';
import { Link, useLocation } from 'react-router-dom';
import ProformaInvoiceModal from './ProformaInvoiceModal';
import ProformaInvoicePreview from './ProformaInvoicePreview';
import TaxDetailsList from './TaxDetailsList';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Container, Card, Tabs, Tab, Button, Offcanvas } from 'react-bootstrap';
import { BiPencil } from "react-icons/bi";
import { BsChevronLeft } from "react-icons/bs";
import { FaFileInvoice, FaReceipt } from "react-icons/fa";

const ProformaInvoiceList = ({ quotationId, show, onHide }) => {
    const [proformainvoices, setPerformaInvoices] = useState([]);
    const [quotationData, setQuotationData] = useState(null);

    const [showModal, setShowModal] = useState(false);
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [selectedPreviewInvoice, setSelectedPreviewInvoice] = useState(null);
    const [selectedPerformaInvoiceId, setSelectedPerformaInvoiceId] = useState(null);
    const [selectedPerformaInvoiceData, setSelectedPerformaInvoiceData] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [activeTab, setActiveTab] = useState('profoList'); // Active tab state
    const [setupIdError, setSetupIdError] = useState('');
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const quotation_id = queryParams.get('quotation_id') || quotationId; // Use prop or query parameter

    const isPerformaInvoiceDetailsPage = location.pathname.includes('/proformainvoice/details/');

    useEffect(() => {
        if (!isPerformaInvoiceDetailsPage && quotation_id && currentPage === 0) {
            fetchPerformaInvoices(1); // Fetch orders only if we're on the list page
        }
    }, [quotation_id, currentPage, isPerformaInvoiceDetailsPage]);
    // Utility function at the top of the file
    // const splitOrderByRevenueType = (order) => {
    //     const subscriptionItems = [];
    //     const deploymentItems = [];
    //     let subscriptionTotal = 0;
    //     let deploymentTotal = 0;

    //     order.quotation?.product_item_details?.forEach(item => {
    //         const revenueType = item.product?.revenue_type;
    //         const itemTotal = parseFloat(item.subtotal) || 0;

    //         if (revenueType === 'deferred') {
    //             subscriptionItems.push(item);
    //             subscriptionTotal += itemTotal;
    //         } else if (revenueType === 'immediate') {
    //             deploymentItems.push(item);
    //             deploymentTotal += itemTotal;
    //         }
    //     });

    //     return {
    //         subscription: {
    //             items: subscriptionItems,
    //             total: subscriptionTotal,
    //             count: subscriptionItems.length
    //         },
    //         deployment: {
    //             items: deploymentItems,
    //             total: deploymentTotal,
    //             count: deploymentItems.length
    //         }
    //     };
    // };
    // Split order by revenue type
const splitOrderByRevenueType = (order) => {
    const quotation = order.quotation;
    
    // Get totals from quotation data
    const totalAmountWithSubscription = parseFloat(quotation?.total_amount_with_subscription) || 0;
    const deploymentAmount = parseFloat(quotation?.deplyment_amount) || 0;
    
    // If we have the actual amounts from quotation, use them
    if (totalAmountWithSubscription > 0 || deploymentAmount > 0) {
        const subscriptionItems = [];
        const deploymentItems = [];
        
        // Distribute products based on their characteristics
        quotation?.product_item_details?.forEach(item => {
            const product = item.product;
            const isServiceProduct = product?.license_type?.toLowerCase() === 'service';
            
            if (isServiceProduct) {
                deploymentItems.push(item);
            } else {
                subscriptionItems.push(item);
            }
        });

        return {
            subscription: {
                items: subscriptionItems,
                total: totalAmountWithSubscription,
                perMonthTotal: totalAmountWithSubscription / (quotation?.subscription_period || 1),
                count: subscriptionItems.length
            },
            deployment: {
                items: deploymentItems,
                total: deploymentAmount,
                count: deploymentItems.length
            }
        };
    }

    // Fallback to calculation based on pricing data
    const subscriptionItems = [];
    const deploymentItems = [];
    let subscriptionTotal = 0;
    let deploymentTotal = 0;

    const subscriptionPeriod = quotation?.subscription_period || 1;
    const selectedLicenseType = quotation?.license_type_name?.toLowerCase();

    quotation?.product_item_details?.forEach(item => {
        const product = item.product;
        const pricings = product?.pricings || [];
        
        // Find matching pricing
        let matchingPricing = null;
        if (selectedLicenseType && pricings.length > 0) {
            matchingPricing = pricings.find(p => 
                p.license_model?.toLowerCase() === selectedLicenseType
            );
        }
        if (!matchingPricing && pricings.length > 0) {
            matchingPricing = pricings[0];
        }

        const isServiceProduct = product?.license_type?.toLowerCase() === 'service';

        if (matchingPricing) {
            const subscriptionAmount = parseFloat(matchingPricing.price) || 0;
            const deploymentAmount = parseFloat(matchingPricing.deployment_cost) || 0;
            const itemQuantity = parseFloat(item.quantity) || 1;

            if (isServiceProduct) {
                // Service products go to deployment
                const itemDeploymentTotal = deploymentAmount * itemQuantity;
                if (itemDeploymentTotal > 0) {
                    deploymentItems.push({
                        ...item,
                        deploymentAmount: itemDeploymentTotal,
                        totalAmount: itemDeploymentTotal
                    });
                    deploymentTotal += itemDeploymentTotal;
                }
            } else {
                // Regular products: both subscription and deployment
                const itemSubscriptionTotal = subscriptionAmount * itemQuantity;
                const itemDeploymentTotal = deploymentAmount * itemQuantity;

                if (itemSubscriptionTotal > 0) {
                    subscriptionItems.push({
                        ...item,
                        amountPerMonth: itemSubscriptionTotal,
                        totalAmount: itemSubscriptionTotal * subscriptionPeriod
                    });
                    subscriptionTotal += itemSubscriptionTotal * subscriptionPeriod;
                }

                if (itemDeploymentTotal > 0) {
                    deploymentItems.push({
                        ...item,
                        deploymentAmount: itemDeploymentTotal,
                        totalAmount: itemDeploymentTotal
                    });
                    deploymentTotal += itemDeploymentTotal;
                }
            }
        } else {
            // Fallback
            const itemTotal = parseFloat(item.subtotal) || 0;
            if (isServiceProduct) {
                deploymentItems.push({
                    ...item,
                    deploymentAmount: itemTotal,
                    totalAmount: itemTotal
                });
                deploymentTotal += itemTotal;
            } else {
                subscriptionItems.push({
                    ...item,
                    amountPerMonth: itemTotal,
                    totalAmount: itemTotal * subscriptionPeriod
                });
                subscriptionTotal += itemTotal * subscriptionPeriod;
            }
        }
    });

    return {
        subscription: {
            items: subscriptionItems,
            total: subscriptionTotal,
            perMonthTotal: subscriptionTotal / (subscriptionPeriod || 1),
            count: subscriptionItems.length
        },
        deployment: {
            items: deploymentItems,
            total: deploymentTotal,
            count: deploymentItems.length
        }
    };
};



    const fetchPerformaInvoices = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/proformainvoice?quotation_id=${quotation_id}&page=${page}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
            });

            const { data, current_page, last_page } = response.data.proformainvoice;
            setPerformaInvoices(data);
            setCurrentPage(current_page - 1);
            setPageCount(last_page);
            const fetchedQuotationData = response?.data?.quotation;

            // if (fetchedQuotationData) {
            //     setQuotationData(fetchedQuotationData);  // Set quotation data into state
            //     console.log('Fetched Quotation Data:', fetchedQuotationData);
            // } 
            if (fetchedQuotationData) {
                const quotationWithSplit = {
                    ...fetchedQuotationData,
                    revenueSplit: splitOrderByRevenueType({ quotation: fetchedQuotationData })
                };
                setQuotationData(quotationWithSplit);
            }
            else {
                console.log('Quotation data not found in the response');
            }

        } catch (error) {
            console.error('Error fetching Performainvoice:', error);
        }
    };

    const handleDownloadPDF = async () => {
        try {
            if (!selectedPreviewInvoice?.id) {
                console.error("No invoice selected for download");
                return;
            }
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(
                `${backendUrl}/api/proformainvoice/${selectedPreviewInvoice.id}/download`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                    responseType: 'blob'
                }
            );

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `proforma-invoice-${selectedPreviewInvoice.ref_no || selectedPreviewInvoice.id}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Error downloading PDF:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to download PDF',
                timer: 3000,
                showConfirmButton: false,
            });
        }
    };

    const deletePerformaInvoice = async (id, journalId) => {
        console.log("Delete function triggered"); // Debugging

        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel"
        });

        console.log("Swal result:", result); // Debugging

        if (!result.isConfirmed) {
            console.log("Delete cancelled");
            return; // Exit if the user cancels
        }

        try {
            console.log("Sending DELETE request...");
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const API = process.env.REACT_APP_WEBZASH_URL;
            const API_KEY = process.env.REACT_APP_API_KEY;

            await axios.delete(`${backendUrl}/api/proformainvoice/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });
            if (journalId) {
                await axios.delete(`${API}/api/entries/delete/journal/${journalId}`, {
                    headers: {
                        'x-api-key': API_KEY,
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    }
                });
            }
            // Remove from UI
            setPerformaInvoices((prevInvoices) =>
                prevInvoices.filter(invoice => invoice.id !== id)
            );

            console.log("Delete successful!");

            // Show success alert
            Swal.fire("Deleted!", "The proforma invoice has been deleted.", "success");

        } catch (error) {
            console.error('Error deleting proforma invoice:', error);

            Swal.fire("Error!", "Failed to delete proforma invoice. Please try again.", "error");
        }
    };

    const handleCreateProformaInvoice = (newInvoice) => {
        setPerformaInvoices(prevState => [newInvoice, ...prevState]);
    };
    const handleShowModal = () => {
        // First, ensure quotationData is available

        setShowModal(true);  // Open the modal if quotationData is available

    };

    const handleCloseModal = () => {
        console.log('Modal Closing');
        setShowModal(false);
    };

    const handlePageClick = (data) => {
        const selectedPage = data.selected + 1;
        fetchPerformaInvoices(selectedPage);
    };

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };
    const [dateFilterDropdown, setDateFilterDropdown] = useState(false);
    const [dateRange, setDateRange] = useState({ from: '', to: '' });
    const [orgFilter, setorgFilter] = useState('');
    const [typeFilter, setTypeFilter] = useState('');
    const [filterDropdown, setFilterDropdown] = useState(null);
    const [deals, setDeals] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');



    // const { totalVatAmount, totalAmountWithVat } = calculateTotals();

    const filteredProformas = proformainvoices.filter(item => item.quotation_id === quotationData?.id);
    const sortedProformas = filteredProformas.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    const latestProforma = sortedProformas.length > 0 ? sortedProformas[0] : null;

    const tabContent = (
        <>
            <div className="bg-light px-4 pt-3 border-bottom">
                <ul className="nav nav-tabs nav-tabs-custom border-bottom-0 pb-0 gap-2 mb-0" role="tablist">
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'profoList' ? 'active' : ''}`}
                            onClick={() => setActiveTab('profoList')}
                            role="tab"
                            style={{ border: 'none', background: 'transparent' }}
                        >
                            <FaFileInvoice className="me-2" size={14} /> Proforma Invoice
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'taxList' ? 'active' : ''}`}
                            onClick={() => setActiveTab('taxList')}
                            role="tab"
                            style={{ border: 'none', background: 'transparent' }}
                        >
                            <FaReceipt className="me-2" size={14} /> Tax Invoices
                        </button>
                    </li>
                </ul>
            </div>

            <div className="tab-content p-4 bg-white" style={{ minHeight: '500px', maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
                {activeTab === "profoList" && (
                    <div className="tab-pane active" id="profo-list" role="tabpanel">
                        <div className="mb-3 d-flex justify-content-end">
                            <button
                                type="button"
                                className="btn btn-primary d-flex align-items-center"
                                onClick={() => handleShowModal()}
                            >
                                <i className="mdi mdi-plus me-1"></i> Add Proforma
                            </button>
                        </div>
                        <table className="table table-hover datatable dt-responsive nowrap view-table font-size-13">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Reference Number</th>
                                    <th scope="col">Advanced Amount</th>
                                    <th scope="col"> Received Amount</th>
                                    <th scope="col">Total Amount Received</th>
                                    <th scope="col">Balance Amount</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(proformainvoices) && proformainvoices.length > 0 ? (
                                    proformainvoices.map((proformainvoice, index) => (
                                        <tr key={proformainvoice.id}>
                                            <td>{index + 1}</td>
                                            <td>
                                                <span 
                                                    className="text-primary fw-medium" 
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                        setSelectedPreviewInvoice(proformainvoice);
                                                        setShowPreviewModal(true);
                                                    }}
                                                >
                                                    {proformainvoice.ref_no}
                                                </span>
                                            </td>
                                            <td>{proformainvoice.advanced_amount}%</td>
                                            <td>{proformainvoice.total_with_vat}</td>
                                            <td>{proformainvoice.total_amount_received}</td>
                                            <td>{proformainvoice.balance}%</td>
                                            <td>
                                                <div className="dropdown">
                                                    <i
                                                        className="mdi mdi-dots-horizontal font-size-18"
                                                        data-bs-toggle="dropdown"
                                                        aria-expanded="false"
                                                        style={{ cursor: 'pointer' }}
                                                    ></i>
                                                    <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                        <li>
                                                            <button 
                                                                className="dropdown-item"
                                                                onClick={() => {
                                                                    setSelectedPreviewInvoice(proformainvoice);
                                                                    setShowPreviewModal(true);
                                                                }}
                                                            >
                                                                View Details
                                                            </button>
                                                        </li>
                                                        <li>
                                                            <button
                                                                className="dropdown-item"
                                                                onClick={() => deletePerformaInvoice(proformainvoice.id, proformainvoice.journal_id)}
                                                            >
                                                                Delete
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center text-muted py-4">
                                            <i className="mdi mdi-file-document-outline display-4 mb-3 d-block"></i>
                                            No proforma invoices found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
                {activeTab === "taxList" && (
                    <div className="tab-pane active" id="tax-list" role="tabpanel">
                        <table className="table table-hover datatable dt-responsive nowrap view-table font-size-13">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">PI Id</th>
                                    <th scope="col">Tax Id</th>
                                    <th scope="col">VAT Amount</th>
                                    <th scope="col">Total Amount with VAT</th>
                                </tr>
                            </thead>
                            <tbody>
                                {proformainvoices
                                    .filter(invoice => invoice.tax_invoice_generated)
                                    .map((invoice, index) => (
                                        <tr key={invoice.id}>
                                            <td>{index + 1}</td>
                                            <td>{invoice.ref_no}</td>
                                            <td>{invoice.tax_invoice?.ref_no}</td>
                                            <td>{invoice.tax_invoice?.vat_amount}</td>
                                            <td>{invoice.tax_invoice?.total_with_vat}</td>
                                        </tr>
                                    ))}
                                {proformainvoices.filter(invoice => invoice.tax_invoice_generated).length === 0 && (
                                    <tr>
                                        <td colSpan="5" className="text-center text-muted py-4">
                                            <i className="mdi mdi-receipt text-muted display-4 mb-3 d-block"></i>
                                            No tax invoices found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
            
            <ProformaInvoiceModal
                showModal={showModal}
                handleClose={handleCloseModal}
                quotationData={quotationData || {}} // Pass the fetched quotation data
                quotationId={quotation_id} // Pass the quotationId
                handleCreate={handleCreateProformaInvoice}
                fetchDeals={fetchPerformaInvoices}
            />
            
            <ProformaInvoicePreview
                showModal={showPreviewModal}
                handleClose={() => {
                    setShowPreviewModal(false);
                    setSelectedPreviewInvoice(null);
                }}
                createdInvoice={selectedPreviewInvoice}
                quotationData={quotationData}
                onDownloadPDF={handleDownloadPDF}
            />
        </>
    );

    if (show !== undefined) {
        return (
            <Offcanvas
                show={show}
                onHide={onHide}
                placement="end"
                style={{ width: '1050px' }}
                className="lead-offcanvas"
            >
                <Offcanvas.Header closeButton className="border-bottom bg-white py-3">
                    <div className="d-flex align-items-center">
                        <div className="bg-primary rounded-circle p-2 me-3">
                            <FaFileInvoice className="text-white" size={18} />
                        </div>
                        <div>
                            <h5 className="mb-0 fw-bold text-dark">Proforma Invoices</h5>
                            <small className="text-muted">Ref: {quotationData?.ref_no || 'N/A'}</small>
                        </div>
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body className="p-0 bg-light">
                    {tabContent}
                </Offcanvas.Body>
            </Offcanvas>
        );
    }

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    {/* Page Title */}
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 d-flex align-items-center">
                                    <BsChevronLeft className="back-button1 me-2" onClick={() => navigate(-1)} style={{ cursor: 'pointer' }} />
                                    <span>Proforma Invoice</span>
                                </h4>
                            </div>
                        </div>
                    </div>
                    <div className="card shadow-sm border-0">
                        {tabContent}
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ProformaInvoiceList;

